import { device } from "components/styles";
import { useMediaQuery } from "react-responsive";

function useIsMobile() {
  const isMobile = useMediaQuery({ query: `(${device.mobile})` });

  return isMobile;
}

export default useIsMobile;
